import { render, staticRenderFns } from "./CartStockBadge.vue?vue&type=template&id=7948f4df"
import script from "./CartStockBadge.vue?vue&type=script&lang=js"
export * from "./CartStockBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports